import React from 'react';
import { 
  Autocomplete, 
  TextField, 
  FormControl, 
  Box,
  Paper,
  styled,
  Button,
  Typography,
  Divider,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

// Estilizar el componente Paper que se usa en el dropdown
const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 6,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  marginTop: 4,
  overflow: 'hidden',
  '& .MuiAutocomplete-listbox': {
    padding: '4px 0',
    '& .MuiAutocomplete-option': {
      padding: '8px 16px',
      '&[aria-selected="true"]': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
      '&[data-focus="true"]': {
        backgroundColor: `rgba(25, 118, 210, 0.08)`,
      }
    }
  }
}));

// Botón para agregar nuevo elemento
const AddButton = styled(Button)(({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  padding: '8px 16px',
  borderRadius: 0,
  textTransform: 'none',
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: `rgba(25, 118, 210, 0.08)`,
  }
}));

const AutocompleteWithAddButton = ({
  options,
  value,
  onChange,
  label,
  required,
  onAddNewClick,
  ...rest
}) => {
  const [open, setOpen] = React.useState(false);
  
  // Renderizar lista personalizada
  const renderOption = (props, option) => {
    return (
      <li {...props} key={option.id}>
        <Typography>{option.nombre}</Typography>
      </li>
    );
  };

  const handleAddButtonClick = (event) => {
    // Detener la propagación para evitar que el Autocomplete se cierre
    event.preventDefault();
    event.stopPropagation();
    
    // Cerrar el Autocomplete manualmente
    setOpen(false);
    
    // Llamar a la función para abrir el modal
    onAddNewClick();
  };

  return (
    <FormControl fullWidth>
      <Autocomplete
        fullWidth
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        noOptionsText="No hay opciones disponibles"
        options={options}
        getOptionLabel={(option) => option.nombre || ''}
        PaperComponent={({ children, ...props }) => (
          <StyledPaper {...props}>
            {children}
            <Divider />
            <Box 
              onClick={(e) => e.stopPropagation()} 
              onMouseDown={(e) => e.preventDefault()}
            >
              <AddButton
                startIcon={<AddIcon />}
                onClick={handleAddButtonClick}
              >
                Agregar {label}
              </AddButton>
            </Box>
          </StyledPaper>
        )}
        renderOption={renderOption}
        renderInput={(params) => (
          <TextField 
            {...params} 
            label={label} 
            required={required}
            margin="normal"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
              }
            }}
          />
        )}
        value={value || null}
        onChange={onChange}
        {...rest}
      />
    </FormControl>
  );
};

export default AutocompleteWithAddButton;